<template>
  <div class="my-promotion">
    <div class="header">
      <div class="name acea-row row-center-wrapper">
        <div>当前余额</div>
        <router-link class="record" :to="'/user/cashrecord'">
          提现记录<span class="iconfont icon-xiangyou"></span>
        </router-link>
      </div>
      <div class="num">{{ userInfo.now_money || 0 }}</div>
      <!-- <div class="profit acea-row row-between-wrapper">
        <div class="item">
          <div>昨日收益</div>
          <div class="money">{{ userInfo.yesterDay || 0 }}</div>
        </div>
        <div class="item">
          <div>累积已提</div>
          <div class="money">{{ userInfo.extractTotalPrice || 0 }}</div>
        </div>
      </div> -->
    </div>
    <div class="bnt bg-color-red" @click="toCash">立即提现</div>
    <div class="list acea-row row-between-wrapper">
      <div
        class="item acea-row row-center-wrapper row-column"
        @click="goinvite"
      >
        <span class="iconfont icon-erweima"></span>
        <div>推广名片</div>
      </div>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/promoter_list'"
      >
        <span class="iconfont icon-tongji"></span>
        <div>推广人统计</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/bill/0'"
      >
        <span class="iconfont icon-qiandai"></span>
        <div>余额记录</div>
      </router-link>
      <!-- <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/promoter_order'"
      >
        <span class="iconfont icon-dingdan"></span>
        <div>推广人订单</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/promoter_rank'"
      >
        <span class="iconfont icon-paihang1"></span>
        <div>推广人排行</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/commission/rank'"
      >
        <span class="iconfont icon-paihang"></span>
        <div>佣金排行</div>
      </router-link> -->
    </div>
  </div>
</template>
<script>
import { getUser } from "../../../api/user";
import { isdouyin } from "@utils/index";
import tt from "@assets/js/tt.js";
export default {
  name: "UserPromotion",
  components: {},
  props: {},
  data: function() {
    return {
      userInfo: {}
    };
  },
  watch: {
    $route(n) {
      if (n.name == "UserPromotion") this.getInfo();
    }
  },
  mounted: function() {
    this.getInfo();
  },
  methods: {
    goinvite() {
      if (isdouyin()) {
        tt.tt.miniProgram.navigateTo({
          url: `/pages/invite/index` // 指定页面的url
        });
      } else {
        this.$router.push({
          path: "/user/poster"
        });
      }
    },
    getInfo: function() {
      let that = this;
      getUser().then(
        res => {
          that.userInfo = res.data;
          // console.log(that.userInfo);
          // if (res.data.level == 0) {
          //   that.$dialog.message("您还未成为推广商,请先成为推广商!");
          //   setTimeout(function() {
          //     that.$router.go(-1);
          //   }, 1500);
          //   return;
          // }
        },
        function(err) {
          that.$dialog.message(err.msg);
        }
      );
    },
    toCash: function() {
      this.$router.push({ path: "/user/cash?type=now_money" });
    }
  }
};
</script>
